import React from "react";

function GreyCrossIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09753 17.3008C6.81428 17.3008 4.62429 16.3937 3.00988 14.7792C1.39537 13.1645 0.488281 10.9748 0.488281 8.69153C0.488281 6.40829 1.39537 4.21829 3.00988 2.60389C4.62452 0.98938 6.81428 0.0822868 9.09753 0.0822868C11.3808 0.0822868 13.5708 0.98938 15.1852 2.60389C16.7997 4.21853 17.7068 6.40829 17.7068 8.69153C17.704 10.974 16.7962 13.1624 15.1822 14.7762C13.5682 16.3901 11.3798 17.298 9.09753 17.3008ZM12.4176 6.47725V6.47712C12.5685 6.33129 12.6546 6.13096 12.6564 5.92105C12.6583 5.71115 12.5757 5.50925 12.4273 5.36079C12.2788 5.21233 12.0769 5.12979 11.867 5.13163C11.6571 5.13346 11.4568 5.21955 11.3109 5.37049L9.09753 7.5847L6.88412 5.37049C6.68535 5.17853 6.4001 5.10555 6.13347 5.17866C5.86697 5.25178 5.65878 5.45998 5.58565 5.72648C5.51254 5.99312 5.58552 6.27836 5.77748 6.47713L7.99089 8.69135L5.77748 10.9056C5.62654 11.0514 5.54045 11.2517 5.53862 11.4616C5.53678 11.6715 5.61933 11.8734 5.76778 12.0219C5.91623 12.1704 6.11813 12.2529 6.32804 12.2511C6.53795 12.2492 6.73827 12.1631 6.88411 12.0122L9.09752 9.79798L11.3109 12.0122C11.4568 12.1631 11.6571 12.2492 11.867 12.2511C12.0769 12.2529 12.2788 12.1703 12.4273 12.0219C12.5757 11.8734 12.6583 11.6715 12.6564 11.4616C12.6546 11.2517 12.5685 11.0514 12.4176 10.9056L10.2042 8.69135L12.4176 6.47725Z"
        fill="#E6E6E6"
      />
    </svg>
  );
}

export default GreyCrossIcon;
